import script from "./PatientOF.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientOF.vue?vue&type=script&setup=true&lang=js"

import "./PatientOF.vue?vue&type=style&index=0&id=73c87d3d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c87d3d"]])

export default __exports__